<template>
    <div class="mt-5">
        <h4>Your recent claims</h4>
        <table class="table mt-5">
            <thead>
                <tr>
                    <th scope="col">Claim Reference</th>
                    <th scope="col">Related Reference</th>
                    <th scope="col">Policy Number</th>
                    <th scope="col">Email</th>
                    <th scope="col">Last Viewed</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(cl, idx) in data" :key="'recentClaimList_' + idx">
                    <td><a href="javascript:void(0)" v-on:click="goToClaim(cl.claimId, idx)">{{cl.claimReference}}</a></td>
                    <td>{{cl.relatedReference}}</td>
                    <td>{{cl.policyNumber}}</td>
                    <td>{{cl.email}}</td>
                    <td>{{cl.lastViewed}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    export default {
        props: {
            data: {
                type: Array,
                required: false,
                default: () => { return [] }
            }
        }
    }
</script>